import { createSlice } from "@reduxjs/toolkit";
import {
  getAreas,
  newArea,
  editArea,
  delArea,
  toggleArea
} from "../../api/Areas";

export const areaSlice = createSlice({
  name: "areas",
  initialState: {
    areas: [],
  },
  reducers: {
    setAreas: (state, action) => {
      state.areas = action.payload;
    },
    setArea: (state, action) => {
      const index = state.areas.findIndex(
        (el) => el.id === action.payload.id
      );
      if (index > -1) {
        state.areas[index] = action.payload;
      }
    },
    addArea: (state, action) => {
      state.areas.push(action.payload);
    },
    removeArea: (state, action) => {
      const index = state.areas.findIndex((el) => el.id === action.payload);
      if (index > -1) {
        state.areas.splice(index, 1);
      }
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setAreas,
  setArea,
  addArea,
  removeArea
} = areaSlice.actions;

export const getAllAreas = () => async (dispatch) => {
  try {
    const response = await getAreas();
    if (!response.error && response.status === 200) {
      dispatch(setAreas(response.data.areas));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const createArea = (data) => async (dispatch) => {
  try {
    const response = await newArea(data);
    if (!response.error && response.status === 200) {
      dispatch(setAreas(response.data.areas));
      return {
        status: "success",
        area: response.data,
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const availableArea = (data) => async (dispatch) => {
  try {
    const response = await toggleArea(data);
    if (!response.error && response.status === 200) {
      dispatch(setAreas(response.data.areas));
      return {
        status: "success",
        area: response.data.area,
      };
    }
    return {
      status: "error",
      type: "unknown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const updateArea = (data) => async (dispatch) => {
  try {
    const response = await editArea(data);
    if (!response.error && response.status === 200) {
      dispatch(setAreas(response.data.areas));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const deleteArea = (id) => async (dispatch) => {
  try {
    const response = await delArea(id);
    if (!response.error && response.status === 200) {
      dispatch(removeArea(id));
      return {
        status: "success",
        // departments: response.data,
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const selectAreas = (state) => state.areas.areas;
export default areaSlice.reducer;
